module.exports = __webpack_public_path__ + "static/media/undo-light.ff41e758.svg";